export default "__VITE_ASSET__44qY03Vf__"